<template>
  <div class="chat-right">
    <div class="header">
      <avatar :username="userNameAvatar(username)" :size="30"></avatar>
      <span>{{ username }}</span>
    </div>
    <div
      class="chat-area"
      @contextmenu.prevent.stop="hiddenContext"
      @scroll="onChatScroll"
    >
      <div
        v-for="(item, index) in dataMessages"
        :key="index"
        class="message"
        :class="item.idUser === id ? 'message-left' : 'message-right'"
      >
        <div class="time">{{ formatTime(item.time) }}</div>
        <div class="content-wrapper">
          <b-avatar
            v-if="item.idUser === id"
            variant="primary"
            text="A"
          ></b-avatar>
          <b-avatar v-else></b-avatar>
          <div
            class="content"
            @contextmenu.prevent.stop="handleClick($event, item)"
            @click="openPreviewImg(item)"
          >
            <div class="img" v-if="checkImg(item.message)">
              <img :src="getImgUrl(item.message)" />
            </div>
            <span v-else v-html="item.message"></span>
          </div>
        </div>
        <!-- <div class="time"><small>Read</small></div> -->
      </div>
    </div>
    <div class="input-chat">
      <div class="emoji-select" v-if="showEmoji" ref="emojiContainer">
        <VEmojiPicker @select="selectEmoji" />
      </div>
      <div class="box-chat-wrap" v-if="showMedia">
        <div class="preview-img">
          <svg
            width="15"
            height="15"
            x="0"
            y="0"
            viewBox="0 0 348.333 348.334"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
            @click="removeMedia()"
          >
            <g xmlns="http://www.w3.org/2000/svg">
              <path
                d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85   c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563   c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85   l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554   L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"
                fill="#000"
                data-original="#000000"
                class=""
              ></path>
            </g>
          </svg>
          <img :src="mediaSrc" />
          <b-progress
            :value="uploadPercent"
            show-progress
            animated
            style="margin-top: 10px"
            v-if="uploading"
          ></b-progress>
        </div>
      </div>

      <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click.stop="showEmoji = !showEmoji"
      >
        <g id="Emoji Icon">
          <path
            id="Vector"
            d="M11.6419 1.995C16.8768 1.995 21.1204 6.23864 21.1204 11.4735C21.1204 16.7075 16.8768 20.9511 11.6419 20.9511C6.40697 20.9511 2.16333 16.7075 2.16333 11.4735C2.16333 6.23864 6.40697 1.995 11.6419 1.995ZM11.6419 3.41649C10.5765 3.40494 9.51944 3.60479 8.53184 4.00449C7.54424 4.40419 6.64572 4.99579 5.88828 5.74506C5.13084 6.49433 4.52952 7.38638 4.11914 8.36959C3.70875 9.3528 3.49745 10.4076 3.49745 11.4731C3.49745 12.5385 3.70875 13.5933 4.11914 14.5765C4.52952 15.5597 5.13084 16.4518 5.88828 17.2011C6.64572 17.9503 7.54424 18.5419 8.53184 18.9416C9.51944 19.3413 10.5765 19.5412 11.6419 19.5296C13.7571 19.4972 15.7747 18.6341 17.259 17.1269C18.7433 15.6196 19.5753 13.589 19.5753 11.4735C19.5753 9.35807 18.7433 7.32748 17.259 5.8202C15.7747 4.31292 13.7571 3.44988 11.6419 3.41744V3.41649ZM8.28903 14.1109C8.68776 14.6188 9.19685 15.0294 9.77774 15.3115C10.3586 15.5935 10.9961 15.7397 11.6419 15.739C12.2868 15.7397 12.9235 15.5938 13.5038 15.3125C14.0842 15.0311 14.593 14.6215 14.9919 14.1147C15.1087 13.9668 15.2796 13.8713 15.4668 13.8494C15.654 13.8274 15.8423 13.8808 15.9902 13.9976C16.1381 14.1145 16.2336 14.2853 16.2555 14.4726C16.2775 14.6598 16.2241 14.8481 16.1073 14.996C15.5754 15.6713 14.8971 16.217 14.1236 16.5919C13.35 16.9669 12.5015 17.1613 11.6419 17.1605C10.7812 17.1612 9.93155 16.9662 9.15729 16.5902C8.38304 16.2142 7.70439 15.6671 7.17268 14.9903C7.06104 14.8419 7.01195 14.6556 7.03591 14.4714C7.05988 14.2872 7.15499 14.1197 7.30089 14.0048C7.4468 13.8899 7.6319 13.8366 7.81658 13.8564C8.00126 13.8763 8.17085 13.9676 8.28903 14.1109ZM8.79887 8.39267C8.95719 8.3882 9.1148 8.41551 9.26238 8.473C9.40996 8.53049 9.54451 8.617 9.65807 8.72739C9.77163 8.83779 9.86191 8.96984 9.92355 9.11574C9.98519 9.26163 10.017 9.4184 10.017 9.57678C10.017 9.73516 9.98519 9.89194 9.92355 10.0378C9.86191 10.1837 9.77163 10.3158 9.65807 10.4262C9.54451 10.5366 9.40996 10.6231 9.26238 10.6806C9.1148 10.7381 8.95719 10.7654 8.79887 10.7609C8.49063 10.7522 8.19793 10.6236 7.98299 10.4025C7.76804 10.1814 7.6478 9.88515 7.6478 9.57678C7.6478 9.26841 7.76804 8.9722 7.98299 8.75109C8.19793 8.52997 8.49063 8.4014 8.79887 8.39267ZM14.4849 8.39267C14.6432 8.3882 14.8008 8.41551 14.9484 8.473C15.0959 8.53049 15.2305 8.617 15.3441 8.72739C15.4576 8.83779 15.5479 8.96984 15.6095 9.11574C15.6712 9.26163 15.7029 9.4184 15.7029 9.57678C15.7029 9.73516 15.6712 9.89194 15.6095 10.0378C15.5479 10.1837 15.4576 10.3158 15.3441 10.4262C15.2305 10.5366 15.0959 10.6231 14.9484 10.6806C14.8008 10.7381 14.6432 10.7654 14.4849 10.7609C14.1766 10.7522 13.8839 10.6236 13.669 10.4025C13.454 10.1814 13.3338 9.88515 13.3338 9.57678C13.3338 9.26841 13.454 8.9722 13.669 8.75109C13.8839 8.52997 14.1766 8.4014 14.4849 8.39267Z"
            fill="#8C84EC"
          />
        </g>
      </svg>
      <label class="d-block">
        <svg
          width="22"
          height="22"
          xmlns="http://www.w3.org/2000/svg"
          class="ionicon"
          viewBox="0 0 512 512"
          @click="removeMedia()"
        >
          <rect
            x="48"
            y="80"
            width="416"
            height="352"
            rx="48"
            ry="48"
            fill="none"
            stroke="#8C84EC"
            stroke-linejoin="round"
            stroke-width="32"
          />
          <circle
            cx="336"
            cy="176"
            r="32"
            fill="none"
            stroke="#8C84EC"
            stroke-miterlimit="10"
            stroke-width="32"
          />
          <path
            d="M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352M224 432l123.34-123.34a32 32 0 0143.11-2L464 368"
            fill="none"
            stroke="#8C84EC"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
          />
        </svg>
        <input
          type="file"
          hidden
          ref="upload-input"
          @change="upload"
          accept="image/*"
        />
      </label>
      <textarea
        class="chat-textarea"
        v-model="chatText"
        placeholder="Message"
        rows="3"
        max
        ref="chatTextarea"
        @paste="onPaste"
        @keypress.enter.exact.prevent="sendChat()"
        @keypress.enter.shift.exact.prevent="breakLineChat()"
      ></textarea>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="sendChat()"
        v-if="!isEditing"
      >
        <g id="Send Icon">
          <path
            id="Vector"
            d="M12.3455 11.6593L5.20768 12.8496C5.12562 12.8633 5.04861 12.8983 4.9844 12.9512C4.92019 13.0041 4.87103 13.073 4.84188 13.1509L2.3808 19.7438C2.14578 20.3504 2.77977 20.9284 3.36163 20.6375L20.4196 12.1085C20.5377 12.0495 20.6371 11.9588 20.7066 11.8465C20.776 11.7341 20.8128 11.6047 20.8128 11.4726C20.8128 11.3406 20.776 11.2111 20.7066 11.0988C20.6371 10.9865 20.5377 10.8957 20.4196 10.8368L3.36163 2.30778C2.77977 2.01684 2.14578 2.59587 2.3808 3.20142L4.84283 9.79432C4.87185 9.87242 4.92094 9.94149 4.98516 9.99457C5.04938 10.0476 5.12646 10.0828 5.20863 10.0966L12.3464 11.2859C12.3904 11.2936 12.4302 11.3166 12.4589 11.3507C12.4875 11.3849 12.5033 11.428 12.5033 11.4726C12.5033 11.5172 12.4875 11.5604 12.4589 11.5945C12.4302 11.6287 12.3904 11.6516 12.3464 11.6593H12.3455Z"
            fill="#7167E8"
          />
        </g>
      </svg>
      <template v-else>
        <div>
          <div style="cursor: pointer">
            <b-badge variant="warning" @click="editMessage">Chỉnh sửa</b-badge>
          </div>
          <div style="cursor: pointer" class="mt-2">
            <b-badge variant="danger" @click="cancelEdit">Hủy</b-badge>
          </div>
        </div>
      </template>
    </div>
    <VueSimpleContextMenu
      :elementId="'myUniqueId'"
      :options="conTextMenuOptions"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Avatar from "vue-avatar";
import { VEmojiPicker } from "v-emoji-picker";
import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);
import { BProgress } from "bootstrap-vue";

import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import VueSimpleContextMenu from "vue-simple-context-menu";
import { BBadge, BAvatar } from "bootstrap-vue";
import moment from "moment";
import imagePreview from "image-preview-vue";
import "image-preview-vue/lib/imagepreviewvue.css";
import debounce from "lodash.debounce";

export default {
  props: {
    id: String,
    username: String,
    dataMessages: Array,
  },
  components: {
    Avatar,
    VEmojiPicker,
    BProgress,
    VueSimpleContextMenu,
    BBadge,
    BAvatar,
  },
  data() {
    return {
      showEmoji: false,
      chatText: "",
      file: null,
      showMedia: false,
      uploading: false,
      uploadPercent: 0,
      editingMessage: null,
      isEditing: false,
      conTextMenuOptions: [
        {
          name: "Chỉnh sửa",
          slug: "edit",
        },
        {
          type: "divider",
        },

        {
          name: "Thu hồi",
          slug: "remove",
        },

        {
          name: "Sao chép",
          slug: "copy",
        },
      ],
    };
  },
  computed: {
    mediaSrc() {
      if (this.file) {
        return URL.createObjectURL(this.file);
      } else if (
        this.editingMessage &&
        this.checkImg(this.editingMessage.message)
      ) {
        return this.getImgUrl(this.editingMessage.message);
      }
      return null;
    },
  },
  methods: {
    selectEmoji(emoji) {
      this.chatText += emoji.data;
    },
    formatTime(timestamp) {
      // let h = new Date(timestamp).getHours();
      // let m = new Date(timestamp).getMinutes();

      // h = h < 9 ? "0" + h : h;
      // m = m < 9 ? "0" + m : m;

      // return h + ":" + m;
      return moment(timestamp).format("YYYY/MM/DD HH:mm");
    },
    sendChat() {
      if (this.file) {
        this.uploadHandler((data) => {
          this.$emit("sendChatData", data);
          // const el = document.querySelector(".chat-area");
          // setTimeout(() => {
          //   el.scrollTo({
          //     top: el.scrollHeight,
          //     behavior: "smooth",
          //   });
          // }, 200);
        });
      } else {
        const text = this.chatText.replace(/\n\r?/g, "<br />");
        this.$emit("sendChatData", text);
        this.chatText = "";
        this.resetCursor();
      }
    },
    checkImg(text) {
      if (text.indexOf("/api/util/file") > -1) {
        return true;
      }
      return false;
    },
    getImgUrl(img) {
      return `${process.env.VUE_APP_BASE_URL}${img}`;
    },
    upload() {
      this.file = this.$refs["upload-input"].files[0];
      if (!this.file) return;
      this.showMedia = true;
    },
    removeMedia() {
      this.$refs["upload-input"].value = "";
      this.showMedia = false;
      this.file = null;
    },
    async uploadHandler(uploadSucess) {
      if (this.file.size > 5 * 1024 * 1024) {
        return this.$toast.error("Dung lượng file quá lớn");
      }
      this.uploading = true;
      const formData = new FormData();
      formData.append("chatFile", this.file);

      const sendFile = await this.$http
        .post(`${process.env.VUE_APP_BASE_URL}/api/util/upload`, formData, {
          onUploadProgress: (ProgressEvent) => {
            let progess = Math.round(
              (ProgressEvent.loaded / ProgressEvent.total) * 100
            );

            this.uploadPercent = progess;
          },
        })
        .catch((err) => {
          return this.$toast.error(err?.response?.data?.error?.message);
        });

      if (sendFile.data) {
        const imageInfo = await this.checkImageDimensions(this.file).catch(
          (error) => {
            console.error(error);
          }
        );
        const sizeImg =
          imageInfo.width > imageInfo.height ? `width=360` : `height=720`;
        const imgUrl = `/api/util/file/${sendFile.data}?${sizeImg}&format=png`;
        this.$toast.success("Đã upload file");
        this.file = null;

        uploadSucess(imgUrl);
        // this.$emit("sendChatData", imgUrl);
        // const el = document.querySelector(".chat-area");
        // setTimeout(() => {
        //   el.scrollTo({
        //     top: el.scrollHeight,
        //     behavior: "smooth",
        //   });
        // }, 100);
      }

      this.$refs["upload-input"].value = "";
      this.file = null;
      this.uploading = false;
      this.showMedia = false;
    },
    checkImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = function () {
          const width = this.width;
          const height = this.height;
          resolve({ width, height });
        };
        image.onerror = function () {
          reject(new Error("Không thể tải hình ảnh."));
        };
        image.src = URL.createObjectURL(file);
      });
    },
    userNameAvatar(userName) {
      if (userName) {
        return userName;
      }
      return "A";
    },

    onPaste(event) {
      var items = event.clipboardData.items;

      for (const index in items) {
        var item = items[index];
        if (item.kind === "file") {
          this.file = item.getAsFile();
          this.showMedia = true;
          this.chatText = "";
          return;
        }
      }
    },

    //
    handleClickOutside(event) {
      const targetElement = this.$refs.emojiContainer;
      if (targetElement && !targetElement.contains(event.target)) {
        this.showEmoji = false;
      }
    },

    hiddenContext() {
      this.$refs.vueSimpleContextMenu.hideContextMenu();
    },

    handleClick(event, item) {
      this.$refs.vueSimpleContextMenu.showMenu(event, item);
    },

    optionClicked(event) {
      // console.log(event);
      const { item, option } = event;
      if (option.slug == "edit") {
        this.editingMessage = item;
        if (this.checkImg(item.message)) {
          this.showMedia = true;
          this.chatText = "";
        } else {
          this.showMedia = false;
          this.chatText = item.message;
        }
        this.isEditing = true;
      } else if (option.slug == "remove") {
        const { time, id } = item;
        this.removeMessage({ time, id });
      } else if(option.slug == "copy") {
        this.copyMessage(item);
      }
      // window.alert(JSON.stringify(event));
    },

    editMessage() {
      const { idUser, time } = this.editingMessage;
      if (this.file) {
        this.uploadHandler((data) => {
          this.sendEditMessage({ ...this.editingMessage, message: data });
        });
      } else {
        this.sendEditMessage({
          ...this.editingMessage,
          message: this.chatText,
        });
      }
    },

    cancelEdit() {
      this.isEditing = false;
      this.showMedia = false;
      this.chatText = "";
    },

    removeMessage(item) {
      this.$socket.emit(
        "chat",
        { type: "remove-message", data: item },
        (data) => {
          if (data.ok) {
            this.$emit("update-message", { type: "remove", item });
          }
        }
      );
    },

    async copyMessage(item) {
      if(!this.checkImg(item.message)) {
        navigator.clipboard.writeText(item.message);
      } else {
        const imageUrl = this.getImgUrl(item.message)
        const res = await fetch(imageUrl);
        const blob = await res.blob();
        const clipboardData = [new ClipboardItem({[blob.type]: blob })];
        await navigator.clipboard.write(clipboardData);
      }
    },

    sendEditMessage(item) {
      this.$socket.emit(
        "chat",
        { type: "edit-message", data: item },
        (data) => {
          if (data.ok) {
            this.$emit("update-message", { type: "edit", item });
          }
        }
      );
    },

    resetCursor() {
      setTimeout(() => {
        const element = this.$refs.chatTextarea;
        if (element.setSelectionRange) {
          element.focus();
          element.setSelectionRange(0, 0);
        } else if (element.createTextRange) {
          var range = element.createTextRange();
          element.moveStart("character", 0);
          element.select();
        }
      }, 100);
    },

    breakLineChat() {
      this.chatText += "\n";
    },

    openPreviewImg(item) {
      if (this.checkImg(item.message)) {
        const preview = imagePreview({
          initIndex: 0,
          zIndex: 1000,
          images: [this.getImgUrl(item.message)],
          onClose: ()=>{},
        });
      }
    },

    onChatScroll: debounce(function (e) {
      if (e.target.scrollTop < 30) {
        this.$emit("getChatHistory");
      }
    }, 1000)
    //
  },
  mounted() {
    window.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.chat-right {
  background: #fff;
  border-radius: 10px;
  .header {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    span {
      font-size: 11.532px;
      font-weight: 600;
      line-height: 14.415px;
      color: #011627;
      margin-left: 12px;
    }
  }
  .chat-area {
    height: calc(100vh - 300px);
    overflow-y: auto;
    padding: 12px;
    &::-webkit-scrollbar {
      display: none;
    }

    .message:not(:first-child) {
      margin-top: 12px;
    }
    .message-left {
      .time {
        text-align: left !important;
        margin-left: 45px;
      }
    }

    .message-left,
    .message-right {
      // display: flex;
      .content-wrapper {
        display: flex;
      }
      .content {
        display: inline-block;
        max-width: 70%;
        border-radius: 11.372px;
        background: #f1f0f0;
        margin: 0 12px;
        padding: 6px 12px;
        // margin-bottom: 15px;
        .img {
          img {
            max-height: 30vh;
            max-width: 70vh;
          }
        }
        span {
          width: 100%;
          word-break: break-all;
          border-radius: 11.372px;
          color: #011627;
          font-size: 15.163px;
          line-height: 18.953px;
        }
        .time {
          color: #011627;
          font-size: 15.163px;
          text-align: right;
          line-height: 18.953px;
        }
      }
    }

    .message-right {
      .content-wrapper {
        justify-content: end;
      }

      .time {
        text-align: right !important;
        margin-right: 45px;
      }

      .content {
        order: -1;
        background-color: #8780ea;
        .time,
        span {
          color: #fff;
        }
      }
    }
  }
  .input-chat {
    padding: 8px 30px;
    display: flex;
    position: relative;
    .emoji-select {
      position: absolute;
      bottom: 100px;
    }
    .box-chat-wrap {
      position: absolute;
      background-color: #ffffff;
      left: 0;
      right: 0;
      bottom: 90px;
      padding: 15px;
      svg {
        position: absolute;
        right: 15px;
      }
      .preview-img {
        img {
          max-height: 150px;
        }
      }
    }
    .icon-upload {
      margin-left: 5px;
    }
    svg {
      cursor: pointer;
    }
    .chat-textarea {
      border: 1px solid #8c84ec;
      outline: none;
      width: 100%;
      border-radius: 8px;
      padding: 5px 8px;
      margin: 0 10px;
    }
  }
}
</style>
